/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchDetailListResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * get all historical version of a single pouch
 * @summary Get all history of a pouchID
 */
export const getPouchidHistory = (pouchID: string, signal?: AbortSignal) => {
  return customInstance<GetPouchDetailListResponseResponse>({
    url: `/bm-pouch-management/v1/pouch/${pouchID}/history`,
    method: 'get',
    signal,
  });
};

export const getGetPouchidHistoryQueryKey = (pouchID: string) => {
  return [`/bm-pouch-management/v1/pouch/${pouchID}/history`] as const;
};

export const getGetPouchidHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchidHistory>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchidHistory>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchidHistoryQueryKey(pouchID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchidHistory>>> = ({ signal }) =>
    getPouchidHistory(pouchID, signal);

  return { queryKey, queryFn, enabled: !!pouchID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouchidHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchidHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPouchidHistory>>
>;
export type GetPouchidHistoryQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get all history of a pouchID
 */
export const useGetPouchidHistory = <
  TData = Awaited<ReturnType<typeof getPouchidHistory>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchidHistory>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchidHistoryQueryOptions(pouchID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
